var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVrboLogoSolidSquare = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 1150.9 1150.9"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#0e214b",
  d: "M-186.2-49.5h1533.7v1344.3H-186.2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#8ec089",
  d: "m580 723.6 18.1-37-60.5-307.9c-17.2-86.7 2.7-124.6 71.3-137.3v-1.8h-63.2c-18.1 9-56.9 36.1-35.2 139.1z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#e85f24",
  d: "m543.9 798.5 18.1-37-79.5-384.7c-14.4-74.1-8.1-112.9 16.3-135.5v-1.8h-42.4c-13.5 28-17.2 56-2.7 129.1z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#318eee",
  d: "M347 240.4h-45.2v1.8c19.9 24.4 25.3 53.3 41.5 118.3l119.2 550.9h26.2L370.5 358.7c-16.3-72.2-19-91.2-23.5-118.3"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#2474de",
  d: "m508.6 872.6 18.1-36.1-99.3-467.8c-17.2-73.1-13.5-105.7-6.3-129.1h-37.9c-.9 29.8.9 54.2 14.4 116.5z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#76c5f7",
  d: "M258.5 240.4h-47v1.8c43.3 17.2 65 50.6 82.2 127.3 0 .9 117.4 541.8 117.4 541.8h26.2L319 365c-20.8-94.8-42.5-111.9-60.5-124.6"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#e85f24",
  d: "m701.9 480.6 1.8 1.8c66.8-157.1 84-200.5 111.1-241.1v-1.8h-53.3v1.8c4.5 62.3-17.2 120.1-59.6 239.3"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#2474de",
  d: "M865.3 240.4c-56 32.5-89.4 93.9-159.8 243.8l1.8 1.8c80.4-150.8 127.3-211.3 232.1-243.8v-1.8z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#8ec089",
  d: "m698.3 477.9 1.8 1.8c41.5-140 56-202.3 19-239.3h-52.4v1.8c57.8 19.9 70.4 79.5 31.6 235.7"
})));
export { SvgVrboLogoSolidSquare as ReactComponent };
export default __webpack_public_path__ + "4560fa986b1423fb6e2e274087473fed.svg";